import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('DailyBonusWrapper').create(({ theme }) => ({
  proto: {
    width: '66%',
    position: 'relative',
    zIndex: 2,
  },
  root: {
    position: 'relative',
    width: '100%',

    transition: '0.2s ease-in-out',

    maxWidth: '135px',
    aspectRatio: '112/96',
    background: ' rgba(19, 21, 31, 1)',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'end',
    justifyContent: 'center',
    boxShadow: '0px 1px 0px 0px rgba(50, 71, 94, 1), 0px 1px 0px 0px rgba(0, 0, 0, 1) inset;',
    cursor: 'pointer',
    '&[data-isdisabled="true"]': {
      pointerEvents: 'none',
      cursor: 'default',
    },
    '&[data-isloading="true"]': {
      pointerEvents: 'none',
      cursor: 'default',
      filter: 'blur(2px) grayscale(100%)',
      transition: 'ease-in-out 0.2s',
    },
  },

  loadingWrapper: {
    position: 'absolute',
    zIndex: 2,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    '&:before': {
      content: '""',
      display: 'block',
      backgroundColor: 'rgba(41, 41, 41, 0.83)',
      borderRadius: '100%',
      width: '64px',
      height: '64px',
      position: 'absolute',
      top: 'calc(50% - 2px)',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      filter: 'blur(16px)',
    },
  },

  lockerWrapper: {
    position: 'absolute',
    zIndex: 2,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    '&:before': {
      content: '""',
      display: 'block',
      backgroundColor: 'rgba(41, 41, 41, 0.83)',
      borderRadius: '100%',
      width: '72px',
      height: '72px',
      position: 'absolute',
      top: 'calc(50% - 2px)',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      filter: 'blur(16px)',
    },
  },

  lockedIconWrapper: {
    position: 'absolute',
    top: '-5%',
    right: '-5%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '24px',
    aspectRatio: '1/1',
    borderRadius: '100%',
    backgroundColor: theme.colors.button.primary.background,
  },

  imgWrapper: {
    position: 'absolute',
    width: '90%',
    // maxWidth: '200px',
    bottom: '10%',

    img: {
      width: '100%',
      height: '100%',

      '&[data-isclaimed="true"]': {
        filter: 'grayscale(100%)',
      },
    },
  },

  claimedText: {
    fontFamily: 'Space Grotesk',
    fontWeight: 440,
    fontSize: theme.sizes.texts.fontSize.m,
    lineHeight: theme.sizes.texts.lineHeight.l,
    color: theme.colors.text.primary,
  },

  amountText: {
    fontFamily: 'Space Grotesk, Inter',
    fontWeight: 440,
    fontSize: '22px',
    lineHeight: theme.sizes.texts.fontSize.xl,
    color: theme.colors.text.primary,
  },
  smallText: {
    fontFamily: 'Space Grotesk, Inter',
    fontWeight: 440,
    fontSize: '12px',
    lineHeight: theme.sizes.texts.fontSize.s,
    textAlign: 'center',
    color: theme.colors.text.primary,
  },

  textWrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    gap: '2px',
    paddingBottom: '6px',
  },
}))
